//@ts-nocheck
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  fetchRedeemRewardsRequest,
  fetchRedeemRewardsSuccess,
  fetchRedeemRewardsFailure,
  fetchRedeemRewardsPreferenceRequest,
  fetchRedeemRewardsPreferenceSuccess,
  fetchRedeemRewardsPreferenceFailure,
  updateRedeemRewardsPreferenceRequest,
  updateRedeemRewardsPreferenceSuccess,
  updateRedeemRewardsPreferenceFailure,
  redeemRewardSearchRequest,
  redeemRewardSearchSuccess,
  redeemRewardSearchFailure,
  fetchRewardsTransactionRequest,
  fetchRewardsTransactionSuccess,
  fetchRewardsTransactionFailure,
  redeemRewardsPointsRequest,
  redeemRewardsPointsSuccess,
  redeemRewardsPointsFailed,
  redeemRewardsPointsAdjustmentsDetailsRequest,
  redeemRewardsPointsAdjustmentsDetailsSuccess,
  redeemRewardsPointsAdjustmentsDetailsFailed,
  rewardsUserPreferenceRequest,
  rewardsUserPreferenceSuccess,
  rewardsUserPreferenceFailed,
  fetchRedeemRewardsAuthorizationRequest,
  fetchRedeemRewardsAuthorizationSuccess,
  fetchRedeemRewardsAuthorizationFailure,
  updateRedeemRewardsAuthorizationRequest,
  updateRedeemRewardsAuthorizationSuccess,
  updateRedeemRewardsAuthorizationFailure,
  authorizationReprocessRequest,
  authorizationReprocessSuccess,
  authorizationReprocessFailure,
  rewardsPercentageDateRequest,
  rewardsPercentageDateSuccess,
  rewardsPercentageDateFailure,
  noEligibleTransactionFlag,
} from '../reducer/redeemRewardsSlice';
import {
  fetchRedeemRewards,
  fetchRedeemRewardsPreferences,
  updateRedeemRewardsPreferences,
  redeemRewardSearch,
  fetchRewardsTransaction,
  fetchRedeemRewardsPoints,
  fetchRedeemRewardsPointsAdjustmentsDetails,
  RewardsUserPreference,
  fetchRedeemRewardsAuthorization,
  updateRedeemRewardsAuthorization,
  updateRedeemRewardsAuthorizationReprocess,
  fetchRewardsHistoryPercentageDetails,
} from '../api'; // Assuming API paths are correct
import { groupByDate } from '../utils/helper';
import { isWeb } from '../storage';

interface RewardsRedeemersAction {
  type: typeof fetchRedeemRewardsRequest.type;
  payload: {
    accId: string;
    cardLastFourDigits: string;
    redemptionType: string;
  };
}

interface RewardsRedeemersPreferenceAction {
  type: typeof fetchRedeemRewardsPreferenceRequest.type;
  payload: {
    accId: string;
    cardLastFourDigits: string;
    redemptionType: string;
  };
}

interface UpdateRewardsRedeemersPreferenceAction {
  type: typeof updateRedeemRewardsPreferenceRequest.type;
}

interface RedeemRewardSearchAction {
  type: typeof redeemRewardSearchRequest.type;
}

interface rewardsTransactionAction {
  type: typeof fetchRewardsTransactionRequest.type;
}

interface redeemRewardsPointsAction {
  type: typeof redeemRewardsPointsRequest.type;
}

interface redeemRewardsPointsAdjustmentsDetailsAction {
  type: typeof redeemRewardsPointsAdjustmentsDetailsRequest.type;
}

interface rewardsUserPreferenceAction {
  type: typeof rewardsUserPreferenceRequest.type;
}

interface redeemRewardsAuthorizationAction {
  type: typeof fetchRedeemRewardsAuthorizationRequest.type;
}

interface updateRedeemRewardsAuthorizationAction {
  type: typeof updateRedeemRewardsAuthorizationRequest.type;
}

interface updateRedeemRewardsAuthorizationReprocessAction {
  type: typeof authorizationReprocessRequest.type;
}

interface rewardsPercentageDateAction {
  type: typeof rewardsPercentageDateRequest.type;
}

// Fetch rewards redeemers saga
export function* fetchRedeemRewardsSaga(
  action: RewardsRedeemersAction
): Generator<any, void, unknown> {
  try {
    const { accId, cardLastFourDigits, redemptionType } = action.payload;
    const redeemRewardsStatus: any = yield call(
      fetchRedeemRewards,
      'fetch_redeem_reward',
      accId,
      cardLastFourDigits,
      redemptionType
    );
    // If the API response has the redeemers rewards under `data`, modify the structure accordingly.
    yield put(fetchRedeemRewardsSuccess(redeemRewardsStatus)); // Assuming API response has a `status` field
  } catch (error: any) {
    yield put(
      fetchRedeemRewardsFailure(
        error.message || 'Failed to fetch rewards redeemers.'
      )
    );
  }
}

// Fetch rewards redeemers preference saga
export function* fetchRedeemRewardsPreferenceSaga(
  action: RewardsRedeemersPreferenceAction
): Generator<any, void, unknown> {
  try {
    const { accId, cardLastFourDigits, redemptionType } = action.payload;
    const redeemersPreferenceStatus: any = yield call(
      fetchRedeemRewardsPreferences,
      'fetch_redeem_reward_preferences',
      accId,
      cardLastFourDigits,
      redemptionType
    );

    // If the API response has the rewards redeemers preference under `data`, modify the structure accordingly.
    yield put(fetchRedeemRewardsPreferenceSuccess(redeemersPreferenceStatus)); // Assuming API response has a `status` field
  } catch (error: any) {
    yield put(
      fetchRedeemRewardsPreferenceFailure(
        error.message || 'Failed to fetch rewards redeemers.'
      )
    );
  }
}

// Fetch rewards redeemers preference saga
export function* updateRedeemRewardsPreferenceSaga(
  action: UpdateRewardsRedeemersPreferenceAction
): Generator<any, void, unknown> {
  try {
    const {
      accountId,
      cardLastFourDigits,
      redemptionType,
      userIdType,
      emailAddress,
      fixedAccountRedemptionAmount,
      minAccountPurchaseThreshold,
      receiveEmailSw,
      receiveSMSSw,
      redemptionFrequency,
      smsNumber,
      recaptchaToken,
    } = action.payload;
    const updateredeemersPreferenceStatus: any = yield call(
      updateRedeemRewardsPreferences,
      'update_redeem_reward_preferences',
      accountId,
      cardLastFourDigits,
      redemptionType,
      userIdType,
      emailAddress,
      fixedAccountRedemptionAmount,
      minAccountPurchaseThreshold,
      receiveEmailSw,
      receiveSMSSw,
      redemptionFrequency,
      smsNumber,
      recaptchaToken
    );
    // If the API response has the update rewards redeemers preference under `data`, modify the structure accordingly.
    if (isWeb) {
      if (updateredeemersPreferenceStatus?.statusCode == 200) {
        yield put(
          updateRedeemRewardsPreferenceSuccess(updateredeemersPreferenceStatus)
        );
      } else {
        yield put(
          updateRedeemRewardsPreferenceFailure(updateredeemersPreferenceStatus)
        );
      }
    } else {
      yield put(
        updateRedeemRewardsPreferenceSuccess(updateredeemersPreferenceStatus)
      ); // Assuming API response has a `status` field
    }
  } catch (error: any) {
    yield put(
      updateRedeemRewardsPreferenceFailure(
        error || 'Failed to fetch rewards redeemers.'
      )
    );
  }
}

export function* redeemRewardSearchSaga(
  action: RedeemRewardSearchAction
): Generator<any, void, unknown> {
  try {
    const { userId, redemptionType, userIdType, cardLastFourDigits } =
      action.payload;
    const redeemRewardSearchStatus: any = yield call(
      redeemRewardSearch,
      'redeem_reward_search',
      userId,
      redemptionType,
      userIdType,
      cardLastFourDigits
    );
    // If the API response has the redeem reward search under `data`, modify the structure accordingly.
    if (redeemRewardSearchStatus?.statusCode === 200) {
      yield put(redeemRewardSearchSuccess(redeemRewardSearchStatus)); // Assuming API response has a `status` field
    } else {
      yield put(
        redeemRewardSearchFailure(
          error.message || 'Failed to fetch rewards redeemers.'
        )
      );
    }
  } catch (error: any) {
    yield put(
      redeemRewardSearchFailure(
        error.message || 'Failed to fetch rewards redeemers.'
      )
    );
  }
}

// Fetch generate code for device saga
export function* fetchRewardsTransactionSaga(
  action: rewardsTransactionAction
): Generator<any, void, unknown> {
  try {
    console.log('Rewards transaction payload', action.payload);
    const {
      offset,
      limit,
      cardLastFourDigits,
      userId,
      userIdType,
      fromDate,
      toDate,
      isYtd,
    } = action.payload;
    const rewardsTransaction: any = yield call(
      fetchRewardsTransaction,
      'fetch_reward_transaction',
      cardLastFourDigits,
      offset,
      limit,
      userId,
      userIdType,
      fromDate,
      toDate,
      isYtd
    );
    yield put(fetchRewardsTransactionSuccess(rewardsTransaction)); // Assuming API response has a `status` field
  } catch (error: any) {
    console.log('rewardstransaction.....');
    yield put(
      fetchRewardsTransactionFailure(
        error.message || 'Failed to fetch rewards transaction.'
      )
    );
  }
}

export function* fetchRedeemRewardsPointsSaga(
  action: redeemRewardsPointsAction
): Generator<any, void, unknown> {
  try {
    const {
      breakdownlevel,
      pointsRedeem,
      currentBalance,
      previousBalance,
      pointEarned,
      accountId,
      cardLastFourDigits,
      userIdType,
      fromDate,
      toDate,
    } = action.payload;
    const redeemRewardsPointsData: any = yield call(
      fetchRedeemRewardsPoints,
      'redeem_rewards_points',
      breakdownlevel,
      pointsRedeem,
      currentBalance,
      previousBalance,
      pointEarned,
      accountId.replace(/^0+/, ''),
      cardLastFourDigits,
      userIdType,
      fromDate,
      toDate
    );
    yield put(redeemRewardsPointsSuccess(redeemRewardsPointsData)); // Assuming API response has a `status` field
  } catch (error: any) {
    yield put(
      redeemRewardsPointsFailed(
        error.message || 'Failed to fetch redeem rewards points.'
      )
    );
  }
}

export function* fetchRedeemRewardsPointsAdjustmentsDetailsSaga(
  action: redeemRewardsPointsAdjustmentsDetailsAction
): Generator<any, void, unknown> {
  try {
    console.log(
      'Redeem Rewards points AdjustmentsDetails payload',
      action.payload
    );
    const {
      accountId,
      cardLastFourDigits,
      userIdType,
      fromDate,
      toDate,
      excludeOtherAccount,
      isYtd,
    } = action.payload;

    const PointsAdjustmentsDetails: any = yield call(
      fetchRedeemRewardsPointsAdjustmentsDetails,
      'redeem_rewards_points_adjustments_details',
      accountId,
      cardLastFourDigits,
      userIdType,
      fromDate,
      toDate,
      excludeOtherAccount,
      isYtd
    );
    console.log(
      'redeem rewards Points Adjustments Details response',
      PointsAdjustmentsDetails
    );
    yield put(
      redeemRewardsPointsAdjustmentsDetailsSuccess(PointsAdjustmentsDetails)
    ); // Assuming API response has a `status` field
  } catch (error: any) {
    yield put(
      redeemRewardsPointsAdjustmentsDetailsFailed(
        error.message || 'Failed to fetch redeem rewards points.'
      )
    );
  }
}

export function* fetchRewardsUserPreferenceSaga(
  action: rewardsUserPreferenceAction
): Generator<any, void, unknown> {
  try {
    const {
      userId,
      cardLastFourDigits,
      userIdType,
      includeSensitiveIdentifiers,
      programIdentifier,
      includeOnlyPrimary,
    } = action.payload;

    const rewardsUserPreferenceResponse: any = yield call(
      RewardsUserPreference,
      'reward_user_references',
      userId,
      cardLastFourDigits,
      userIdType,
      includeSensitiveIdentifiers,
      programIdentifier,
      includeOnlyPrimary
    );

    yield put(rewardsUserPreferenceSuccess(rewardsUserPreferenceResponse)); // Assuming API response has a `status` field
  } catch (error: any) {
    yield put(
      rewardsUserPreferenceFailed(
        error.message || 'Failed to fetch rewards user preference.'
      )
    );
  }
}

export function* fetchRedeemRewardsAuthorizationSaga(
  action: redeemRewardsAuthorizationAction
): Generator<any, void, unknown> {
  try {
    const { accId, cardLastFourDigits, fromDate, toDate, includeResponse } =
      action.payload;
    const redeemRewardsAuthorizationData: any = yield call(
      fetchRedeemRewardsAuthorization,
      'fetch_reward_authorization',
      accId,
      cardLastFourDigits,
      fromDate,
      toDate,
      includeResponse
    );

    if (redeemRewardsAuthorizationData?.statusCode === 200) {
      const groupedData = yield groupByDate(
        redeemRewardsAuthorizationData?.authorizationList
      );
      const sections = Object.keys(groupedData).map((date) => ({
        title: date,
        data: groupedData[date],
      }));
      yield put(fetchRedeemRewardsAuthorizationSuccess(sections));
      const eligibleItems =
        yield redeemRewardsAuthorizationData?.authorizationList.filter(
          (item) => item.eligibleRogersRedeemBonus
        );
      if (eligibleItems?.length > 0) {
        yield put(noEligibleTransactionFlag(true));
      } else {
        yield put(noEligibleTransactionFlag(false));
      }
    } else {
      yield put(fetchRedeemRewardsAuthorizationSuccess([]));
    }
  } catch (error: any) {
    yield put(
      fetchRedeemRewardsAuthorizationFailure(
        error.message || 'Failed to fetch redeem rewards authorization list.'
      )
    );
  }
}

export function* updateRedeemRewardsAuthorizationSaga(
  action: updateRedeemRewardsAuthorizationAction
): Generator<any, void, unknown> {
  try {
    const {
      accountId,
      accountIdType,
      processingCode,
      cardLastFourDigits,
      cardholderBillingAmount,
      transactionAmount,
      transactionDateAndTime,
      merchantCategoryCode,
      acquiringInstitutionIdCode,
      authorizationIdResponse,
      cardAcceptorIdCode,
      cardAcceptorNameAndLocation,
      cardholderBillingCurrencyCode,
      externalId,
      issuerCountryCode,
    } = action.payload;
    const updateRedeemRewardsAuthorizationData: any = yield call(
      updateRedeemRewardsAuthorization,
      'update_reward_authorization',
      accountId,
      accountIdType,
      processingCode,
      cardLastFourDigits,
      cardholderBillingAmount,
      transactionAmount,
      transactionDateAndTime,
      merchantCategoryCode,
      acquiringInstitutionIdCode,
      authorizationIdResponse,
      cardAcceptorIdCode,
      cardAcceptorNameAndLocation,
      cardholderBillingCurrencyCode,
      externalId,
      issuerCountryCode
    );
    // console.log('redeem rewards authorization response', updateRedeemRewardsAuthorizationData);
    yield put(
      updateRedeemRewardsAuthorizationSuccess(
        updateRedeemRewardsAuthorizationData
      )
    ); // Assuming API response has a `status` field
  } catch (error: any) {
    yield put(
      updateRedeemRewardsAuthorizationFailure(
        error.message || 'Failed to fetch redeem rewards authorization list.'
      )
    );
  }
}

export function* updateRedeemRewardsAuthorizationReprocessSaga(
  action: updateRedeemRewardsAuthorizationReprocessAction
): Generator<any, void, unknown> {
  try {
    const { id, accountId, cardLastFourDigits, accountIdType, processedBy } =
      action.payload;
    const authorizationPreprocessData: any = yield call(
      updateRedeemRewardsAuthorizationReprocess,
      'update_reward_authorization_reprocess',
      id,
      accountId,
      cardLastFourDigits,
      accountIdType,
      processedBy
    );

    if (authorizationPreprocessData?.statusCode === 200) {
      yield put(authorizationReprocessSuccess(authorizationPreprocessData));
    } else {
      yield put(authorizationReprocessFailure(authorizationPreprocessData));
    }
  } catch (error: any) {
    yield put(authorizationReprocessFailure(error));
  }
}

// Fetch generate code for device saga
export function* fetchRewardsPercentageDateSaga(
  action: rewardsPercentageDateAction
): Generator<any, void, unknown> {
  try {
    console.log('payload', action.payload);
    const rewardsPercentage: any = yield call(
      fetchRewardsHistoryPercentageDetails,
      'rewards_history_percentage',
      action.payload
    );
    yield put(rewardsPercentageDateSuccess(rewardsPercentage)); // Assuming API response has a `status` field
  } catch (error: any) {
    yield put(
      rewardsPercentageDateFailure(
        error.message || 'Failed to fetch rewards percentage and date.'
      )
    );
  }
}

// Watch sagas
export function* watchRewardsRedeemersSagas(): Generator<any, void, unknown> {
  yield takeLatest(fetchRedeemRewardsRequest.type, fetchRedeemRewardsSaga);
  yield takeLatest(
    fetchRedeemRewardsPreferenceRequest.type,
    fetchRedeemRewardsPreferenceSaga
  );
  yield takeLatest(
    updateRedeemRewardsPreferenceRequest.type,
    updateRedeemRewardsPreferenceSaga
  );
  yield takeLatest(redeemRewardSearchRequest.type, redeemRewardSearchSaga);
  yield takeLatest(
    fetchRewardsTransactionRequest.type,
    fetchRewardsTransactionSaga
  );
  yield takeLatest(
    redeemRewardsPointsRequest.type,
    fetchRedeemRewardsPointsSaga
  );
  yield takeLatest(
    redeemRewardsPointsAdjustmentsDetailsRequest.type,
    fetchRedeemRewardsPointsAdjustmentsDetailsSaga
  );
  yield takeLatest(
    rewardsUserPreferenceRequest.type,
    fetchRewardsUserPreferenceSaga
  );
  yield takeLatest(
    fetchRedeemRewardsAuthorizationRequest.type,
    fetchRedeemRewardsAuthorizationSaga
  );
  yield takeLatest(
    updateRedeemRewardsAuthorizationRequest.type,
    updateRedeemRewardsAuthorizationSaga
  );
  yield takeLatest(
    authorizationReprocessRequest.type,
    updateRedeemRewardsAuthorizationReprocessSaga
  );
  yield takeLatest(
    rewardsPercentageDateRequest.type,
    fetchRewardsPercentageDateSaga
  );
}
